// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rt9XtaD5FWkV8WjRsVKo{--collapse-container-padding-bottom:32px}.axg00esXk4lNbz0IOZt7{margin-bottom:16px}.Fvb8mWN0aAERJsxbKIM_{margin-right:-6px;display:flex;position:relative}.Fg3OTkMSQ2MCgkOTCYX5{width:calc(100% - 6px);height:100%}.DiBUdBCXLUIcnEedEzTY{width:100%;height:40px;margin-top:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseContent": `Rt9XtaD5FWkV8WjRsVKo`,
	"alert": `axg00esXk4lNbz0IOZt7`,
	"table": `Fvb8mWN0aAERJsxbKIM_`,
	"viewScrollClassName": `Fg3OTkMSQ2MCgkOTCYX5`,
	"addButton": `DiBUdBCXLUIcnEedEzTY`
};
export default ___CSS_LOADER_EXPORT___;
